import { PaginationFilter } from '@liveauctioneers/caterwaul-components/types/PaginationFilter';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import React from 'react';

import { MyFavoritesNoResults } from '@/components/MyFavoritesNoResults/MyFavoritesNoResults';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import SellerTable from '@/components/SellerTable/SellerTable';
import { useAppSelector } from '@/redux/hooks';
import { getFollowedSellerFilters, getTotalFollowedSellerCount } from '@/redux/modules/followSeller';
import { getAuctioneerDirectoryUrl } from '@/utils/urls';

import FollowedSellersFilter from './components/FollowedSellersFilter';

type Props = {
    onFilterChange: (filters: PaginationFilter) => void;
    sellerIds: number[];
};

const FollowedSellersPage = (props: Props) => {
    const { onFilterChange, sellerIds } = props;

    const filters = useAppSelector(getFollowedSellerFilters);
    const totalFollowedSellers = useAppSelector(getTotalFollowedSellerCount);

    const emptyMessage = [
        <FormattedMessage
            id="empty_save_message_part_1"
            key="0"
            tagName="span"
        />,
        <FormattedMessage
            id="empty_save_message_part_2"
            key="1"
            tagName="span"
        />,
        <FormattedMessage
            id="empty_save_message_part_3"
            key="2"
            tagName="span"
            values={{
                link: (
                    <Link
                        className="text-[13px]"
                        data-test-id="empty-save-message-part-3-link"
                        href={getAuctioneerDirectoryUrl()}
                        key="empty-save-message-part-3-link"
                        size="xs"
                    >
                        <FormattedMessage id="auctioneer_directory" />
                    </Link>
                ),
            }}
        />,
    ];

    const showPager = typeof filters.pageSize === 'number' && totalFollowedSellers > filters.pageSize;
    return (
        <div className="mx-auto min-h-[400px] w-full max-w-[1200px] self-center p-0">
            {showPager ? (
                <Pagination
                    filter={
                        <FollowedSellersFilter
                            filters={filters}
                            onFilterChange={onFilterChange}
                        />
                    }
                    onChange={onFilterChange}
                    paginationFilter={{
                        ...filters,
                        totalRecords: totalFollowedSellers,
                    }}
                    shouldModifyQueryParams
                >
                    <SellerTable sellerIds={sellerIds} />
                </Pagination>
            ) : (
                <>
                    <FollowedSellersFilter
                        filters={filters}
                        onFilterChange={onFilterChange}
                    />
                    {sellerIds.length ? (
                        <SellerTable sellerIds={sellerIds} />
                    ) : (
                        <MyFavoritesNoResults>{emptyMessage}</MyFavoritesNoResults>
                    )}
                </>
            )}
        </div>
    );
};

export default FollowedSellersPage;
